module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "center-ns mb4"
  }, [_c('div', {
    staticClass: "mw5-ns center-ns tc mb4 pt4 lh-copy flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    staticClass: "dn",
    attrs: {
      "id": "interval1",
      "type": "radio",
      "name": "interval"
    },
    domProps: {
      "value": 'annual',
      "checked": _vm._q(_vm.interval, 'annual')
    },
    on: {
      "change": function($event) {
        _vm.interval = 'annual'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br1 br--right b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "interval1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.interval = 'annual'
      }
    }
  }, [_vm._v("Annual")]), _vm._v(" "), _c('span', {
    staticClass: "pv2 ph3 tc b silver"
  }, [_vm._v("OR")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    staticClass: "dn",
    attrs: {
      "id": "interval2",
      "type": "radio",
      "name": "interval"
    },
    domProps: {
      "value": 'monthly',
      "checked": _vm._q(_vm.interval, 'monthly')
    },
    on: {
      "change": function($event) {
        _vm.interval = 'monthly'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br1 br--left b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "interval2"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.interval = 'monthly'
      }
    }
  }, [_vm._v("Monthly")])]), _vm._v(" "), _c('div', {
    staticClass: "mb4 center-ns flex-ns flex-wrap justify-center"
  }, [_c('ak-coverage-card', {
    attrs: {
      "name": _vm.selectedOption.name,
      "price": _vm.selectedOption.price,
      "deductible": _vm.selectedOption.deductible,
      "claims": _vm.selectedOption.max_coverage,
      "featured": _vm.interval === 'annual',
      "coverageid": _vm.selectedOption.id,
      "annual": _vm.interval === 'annual',
      "savings": _vm.savings,
      "activationFee": false,
      "planType": _vm.checkoutType
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('ak-coverage-currency-toggle')], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 f7 f5-ns mw7-ns center-ns tc cera-round-pro"
  }, [_c('span', {
    staticClass: "lh-copy"
  }, [_vm._v("Plans can be cancelled at anytime for a pro-rated refund.")]), _vm._v(" "), _c('br'), _vm._v("\n    Contact "), _c('a', {
    staticClass: "color-theme lh-copy",
    attrs: {
      "href": "mailto:billing@getakko.com"
    }
  }, [_vm._v("billing@getakko.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aaf5fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration-v2/ChoosePlan.vue
// module id = 1198
// module chunks = 0